import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { generatePageTitle } from './pageTitleGenerator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBell } from '@fortawesome/free-solid-svg-icons';
import logo from '../../../assets/images/Leaderly_TM.png';
import avatar from './imgs/avatar.png';
import './adminHeader.css';
import { Dropdown, NavDropdown } from 'react-bootstrap';
import { decodeJWT } from '../../../services/candidateService';
import useCurrentPath from '../../../utils/useCurrentPath';
import { useNavigate } from 'react-router-dom';
import { useProfileImage } from '../admin-pages/user-profile/profileImageContext';
const AdminHeader = (props) => {
  const location = useCurrentPath();
  const { profileImageUrl } = useProfileImage();

  const logout = () => {
    localStorage.removeItem('authToken');
    sessionStorage.clear();
    window.location = '/';
  };

  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  return (
    <Container fluid className="pageHeader" style={{ height: 60, padding: 10, backgroundColor: '#fff' }}>
      <Row>
        <Col xxl={2} xl={2} md lg={2}>
          <Row>
            <Col className="d-flex align-items-center">
              <Navbar.Brand href="#home">
                <img src={logo} />
              </Navbar.Brand>
            </Col>
            <Col className="d-flex align-items-center justify-content-end">
              <a href="#">
                <div className="menuToggle ">
                  <FontAwesomeIcon icon={faBars} color="#F35824" size="sm" />
                </div>
              </a>
            </Col>
          </Row>
        </Col>
        <Col className="d-flex align-items-center flex-grow-1">
          <h3 className="page-title">{generatePageTitle(location)}</h3>
        </Col>
        <Col className="d-flex align-items-center justify-content-end" xs="auto">
          <nav className="navbar navbar-expand navbar-light bg-white topbar static-top p-0">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item p-2">
                <a className="me-1" href="#" id="alertsDropdown" role="button">
                  <FontAwesomeIcon icon={faBell} color="#F35824" size="sm" />
                </a>
              </li>
              <NavDropdown
                id="signite-nav-dropdown"
                align="end"
                title={
                  <span className="admin-dropdown-title">
                    <img
                      className="me-1 img-profile rounded-circle"
                      width={40}
                      height={40}
                      src={profileImageUrl}
                      alt="profile"
                    />
                    <span className="admin-username-text d-none d-md-inline">
                      {decoded.username}
                    </span>
                  </span>
                }
                menuVariant="dark"
              >
                <NavDropdown.Item href="/user-profile">Profile</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
              </NavDropdown>

            </ul>
          </nav>
        </Col>
      </Row>
    </Container>
  );
};
export default AdminHeader;